import { memo, type FC, useCallback } from 'react';

import { useGetPostCreationOptions } from '@/features/api/hooks/grapevine-post/useGetPostCreationOptions';
import { useMeinOrtTab } from '@/features/mein-ort/components/MeinOrtTabContext';
import { MeinOrtTab } from '@/features/mein-ort/components/meinOrtTypes';
import { PostCreationContext } from '@/features/post-editor/types/postCreationOptions';
import { getAvailableSenderOptions } from '@/features/post-editor/utils/postCreationOptions';
import { PostFeedType } from '@/features/posts/types/postFeed';
import { SenderType } from '@/features/sender-selection/types/sender';
import { useVerification } from '@/features/verification/providers/useVerification';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';
import { AppRoute } from '@/navigation/types/navigation';
import { FloatingActionButton } from '@/shared/components/FloatingActionButton';

export const MeinOrtSuggestionCreatePostFab: FC = memo(() => {
  const navigation = useAppNavigation();
  const { ensureVerified } = useVerification();
  const { activeTab } = useMeinOrtTab();
  const isSuggestionTab = activeTab === MeinOrtTab.SAGSUNS;
  const { data: options } = useGetPostCreationOptions(
    PostCreationContext.SAGS_UNS,
    isSuggestionTab
  );
  const canCreate = getAvailableSenderOptions(options).some(
    (sender) =>
      sender.senderType === SenderType.USER &&
      sender.channels.some(
        (channel) => channel.channelType === PostFeedType.SUGGESTION
      )
  );

  const onPress = useCallback(() => {
    if (!ensureVerified()) {
      return;
    }
    navigation.navigate(AppRoute.PostCreationHome, {
      channelType: PostFeedType.SUGGESTION,
      creationContext: PostCreationContext.SAGS_UNS
    });
  }, [navigation, ensureVerified]);

  if (!isSuggestionTab || !canCreate) {
    return;
  }

  return (
    <FloatingActionButton
      testID="mein-ort-suggestion-create-post-fab"
      onPress={onPress}
    />
  );
});
MeinOrtSuggestionCreatePostFab.displayName = 'MeinOrtSuggestionCreatePostFab';
